import React from "react"

export default function Submit(props) {
    const checkIsSubmitted = props.apiData && props.apiData[0].isSubmitted
    const scoreDisplay = <p className="display-score">You scored {props.apiData ? props.apiData[0].score : "0"}/5 correct answer</p>
    console.log(scoreDisplay)
    return <div className="submit-btn-holder">
        {checkIsSubmitted && scoreDisplay}
        <button className="check-answer" onClick={props.onClick}>{checkIsSubmitted ? "Play Again" : "Check your answer"}</button>
    </div>

}